// extracted by mini-css-extract-plugin
export default {"wrapper":"wo-z","response":"xo-z","error":"yo-z","disabled":"zo-z","buttons":"Ao-z","feedbackQuestionSection":"Bo-z","yesNoWrapper":"Co-z"};